import { render, staticRenderFns } from "./TabletBlock.vue?vue&type=template&id=61a65fa4&scoped=true"
import script from "./TabletBlock.vue?vue&type=script&lang=js"
export * from "./TabletBlock.vue?vue&type=script&lang=js"
import style0 from "./TabletBlock.vue?vue&type=style&index=0&id=61a65fa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a65fa4",
  null
  
)

export default component.exports